<template>
  <div class="pages_su_one">
    <div class="pages_ab">
      <div class="pages_title fx fa_c"> 
          <div class="fs_06 fw_6 pr01">公司简介</div>
          <div class=" fs_03 ls2">COMPANY OVERVIEW</div>
      </div>
      <div class="ab_content">
        <img src="@/assets/summany/rongyu/ry_top.png" class="content_img">
        <div class="cfour ml_4">
            <!-- <Text/> -->
           <img :src="t.img" v-for="t in imgList" class="cfour_img mb03  animate__animated  animate__fadeInLeft"/>
        </div>
      </div>

    </div>
   
  </div>
</template>
<script  setup>
import { ref, onMounted } from 'vue'
import img1 from '@/assets/summany/rongyu/img1.jpg'
import img2 from '@/assets/summany/rongyu/img2.jpg'
import img3 from '@/assets/summany/rongyu/img3.jpg'
import img4 from '@/assets/summany/rongyu/img4.jpg'
import img5 from '@/assets/summany/rongyu/img5.jpg'
import img6 from '@/assets/summany/rongyu/img6.jpg'
import img7 from '@/assets/summany/rongyu/img7.jpg'
import img8 from '@/assets/summany/rongyu/img8.jpg'
import img9 from '@/assets/summany/rongyu/img9.jpg'
import img10 from '@/assets/summany/rongyu/img10.jpg'
import img11 from '@/assets/summany/rongyu/img11.jpg'
import img12 from '@/assets/summany/rongyu/img12.jpg'
import img13 from '@/assets/summany/rongyu/img13.jpg'

onMounted(() => {
});
const imgList= ref([
      {  img:img1  },
      {  img:img2  },
      {  img:img3  },
      {  img:img4  },
      {  img:img5  },
      {  img:img6  },
      {  img:img7  },
      {  img:img8  },
      {  img:img9  },
      {  img:img10  },
      {  img:img11  },
      {  img:img12  },
      {  img:img13  },
    ])
</script>
<style  scoped>
.pages_su_one {
  width: 100%;
  height: 100%;
  z-index: 6;
  position: relative;
  overflow-y: auto;
}
.pages_ab{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
 
}
.pages_title{
  position:absolute;
  top: 4%;
  left: 3%;
  color: #fff;

}
.ab_content{
  position: absolute;
  top: 10%;
  left: 0;
  width: 94%;
  margin: 0 3%;
  /* height: 86%; */
  background-color: #fff;
  border-top-left-radius: 0.6rem;
  border-bottom-right-radius: 0.6rem;
  /* overflow-y: auto; */
}
.content_img{
  width: 92%;
  height: auto;
  margin: 4% 4%;
}
.cfour_img{
  width: 100%;
}



</style>

